"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFingerprint = void 0;

var _types = require("../types"); // tslint:disable-next-line


var isBrowser = !!(typeof window !== 'undefined' && window.localStorage);

var getFingerprint = function getFingerprint() {
  if (isBrowser) {
    return window.localStorage[_types.FINGERPRINT];
  }

  return '';
};

exports.getFingerprint = getFingerprint;